import { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, onSnapshot } from "firebase/firestore";

export default function useCompanies() {
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    const q = collection(db, "Companies");
    const unsub = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setCompanies(data);
    });
    return () => unsub();
  }, []);

  return companies;
}
